// extracted by mini-css-extract-plugin
export default {"toaster":"toaster-zDMr8"};